import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DefaultEditorValue } from "../technician/AdminMonthlyWork";
import { ConfirmDefault } from "../components/ConfirmDialogB";
import { CGDObj, CGDService } from "../../model/backoffice/cgd-price";
import {
  ConfirmsDeleteAction,
  GetCreateTable,
  GetListForm,
  ShowsEditor,
} from "../../core/Helper2";
import { IsCanDelete, UserRight, UserRightChecker } from "../../core/Helper3";
import { BuildsColumnsWithEdit } from "../../core/TableHelper";
import { TopToolBar } from "../../core/TopToolbar";
import CGDPriceEditor from "./c0002-cgd-price-editor";
import ConfirmDialog from "../components/ConfirmDialog";

export default function CGDPriceList(props) {
  const userInfo = useSelector((state) => state.user);

  const [list, setList] = props.list;
  const [table, setTable] = useState();
  const [confirm, setConfirm] = useState(ConfirmDefault);
  const [editor, setEditor] = useState(DefaultEditorValue);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState([]);
  const _idFiledsName = "CgdId";

  useEffect(() => {
    if (list?.show) {
      getData();
      return () => {
        setData([]);
        setEditData([]);
        setTable(null);
        setEditor(null);
      };
    }
  }, [list?.show]);

  //** Get data list */
  const getData = async (text) => {
    let ret = await CGDService.GetList({ text: text }, userInfo.detail);

    if (ret) {
      setData(ret);
    }
    setEditor(DefaultEditorValue);
  };

  const actionAddNew = async () => {
    ShowsEditor(setEditor, _idFiledsName, 0, () => getData());
  };

  const dispatch = useDispatch();

  const actionEdit = (x, row) => {
    ShowsEditor(setEditor, _idFiledsName, row[_idFiledsName], () => getData());
  };

  /** DELETE */
  const actionDelete = async (x, row) => {
    if (!IsCanDelete(userInfo.userRule, dispatch)) return;

    ConfirmsDeleteAction(setConfirm, async () => {
      let res = await CGDService.DeleteItem(
        { [_idFiledsName]: row[_idFiledsName] },
        userInfo.detail
      );
      if (res) {
        getData();
      }
    });
  };

  /** Effect DATA */
  useEffect(() => {
    let columns = BuildsColumnsWithEdit(
      CGDObj({}),
      UserRightChecker(userInfo.userRule, UserRight.Admin) ? actionEdit : null,
      UserRightChecker(userInfo.userRule, UserRight.Admin) ? actionDelete : null
    );

    setTable(
      GetCreateTable({
        idFieldName: _idFiledsName,
        columns: columns,
        data: data,
      })
    );
  }, [data]);
  return table ? (
    <>
      <GetListForm
        {...{
          list: [list, setList],
          title: "ราคากรมบัญชีกลาง",
          fullscreen: false,
        }}
      >
        <TopToolBar
          onAddNew={
            UserRightChecker(userInfo.userRule, UserRight.Admin)
              ? actionAddNew
              : null
          }
          addNewTitle={"เพิ่มใหม่"}
          title={"ราคากรมบัญชีกลาง"}
          searchHandler={(text) => getData(text)}
        ></TopToolBar>
        {table}
      </GetListForm>

      <CGDPriceEditor
        {...{ editor: [editor, setEditor], data: [editData, setEditData] }}
      />
      <ConfirmDialog {...{ winState: [confirm, setConfirm] }} />
    </>
  ) : (
    <></>
  );
}
